import ErrorMessage from '@Web/Src/ErrorMessage/index.jsx';
import SvgImage from '@Web/Src/Components/SvgImage';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
const tailwindUsedClasses = ['rounded-lg', 'rounded-l-lg', 'rounded-r-lg'];

function Input(props) {
    const {
        size = 'medium',
        className = '',
        label = '',
        labelClassName = '',
        inputClassName = '',
        containerType = 'fill',
        disabled,
        error,
        description,
        required,
        value,
        leftIcon,
        rightIcon,
        onPressLeftIcon,
        onPressRightIcon,
        boldLabel = true,
        rightSpace = '',
        ...rest
    } = props;

    const getClassNames = () => {
        let baseClasses = `${inputClassName} ${rightSpace} px-3 text-base min-w-32 w-full rounded-[100px] border border-1 text-dark group-focus:text-dark border-solid ${!error ? 'hover:bg-hover focus:bg-surface-input focus:border-blue' : ''} placeholder:text-tertiary  ${leftIcon ? 'pl-10' : ''} ${rightIcon ? 'pr-10' : ''}`;

        if (size === 'medium') {
            baseClasses += ' !h-10';
        } else if (size === 'large') {
            baseClasses += ' !h-14';
        }

        if (disabled) {
            baseClasses +=
                ' text-disabled hover:bg-surface-input cursor-not-allowed bg-surface-input border-transparent';
        } else if (error) {
            baseClasses += ' !border-red-light !bg-surface-error';
        } else if (containerType === 'fill+outline') {
            baseClasses += ' bg-preview-body border-surface-input';
        } else if (containerType === 'outline') {
            baseClasses += ' bg-transparent border-surface-input';
        } else {
            baseClasses += ' bg-surface-input border-transparent';
        }

        return `${baseClasses} `;
    };

    const iconsBaseClasses = `h-6 w-6 absolute top-1/2 -translate-y-1/2 z-10 text-tertiary group-hover:text-secondary group-focus-within:!text-dark ${value ? '!text-dark' : ''}`;

    return (
        <div className={`group ${className}`}>
            {label ? (
                <div
                    className={`${labelClassName} ${boldLabel ? 'font-bold' : 'font-medium'} text-dark group-hover:text-secondary group-focus-within:!text-dark mb-1 text-sm leading-5 ${required ? "after:text-red after:ml-0.5 after:content-['*']" : ''}`}
                >
                    {label}
                </div>
            ) : null}
            <div className={`relative w-full`}>
                {leftIcon && (
                    <SvgImage
                        icon={leftIcon}
                        className={`${iconsBaseClasses} left-3 ${onPressLeftIcon && typeof onPressLeftIcon === 'function' ? 'cursor-pointer' : ''}`}
                        onClick={
                            onPressLeftIcon && typeof onPressLeftIcon === 'function'
                                ? onPressLeftIcon
                                : undefined
                        }
                    />
                )}
                {rightIcon && (
                    <SvgImage
                        icon={rightIcon}
                        className={`${iconsBaseClasses} right-3 ${onPressRightIcon && typeof onPressRightIcon === 'function' ? 'cursor-pointer' : ''}`}
                        onClick={
                            onPressRightIcon && typeof onPressRightIcon === 'function'
                                ? onPressRightIcon
                                : undefined
                        }
                    />
                )}
                <input
                    value={value}
                    disabled={disabled}
                    {...rest}
                    className={getClassNames()}
                />
            </div>
            {!!description && !error && (
                <div
                    className={`text-tertiary group-hover:text-secondary group-focus-within:!text-dark text-sm`}
                >
                    {description}
                </div>
            )}
            <ErrorMessage size={size} error={error} />
        </div>
    );
}

Input.propTypes = {
    size: PropTypes.oneOf(['medium', 'large']),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    required: PropTypes.bool,
    containerType: PropTypes.oneOf(['fill', 'fill+outline', 'outline']),
    value: PropTypes.any,
    leftIcon: PropTypes.string,
    rightIcon: PropTypes.string,
    onPressLeftIcon: PropTypes.func,
    onPressRightIcon: PropTypes.func,
};

export default Input;
